import { IconArrowRight } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { SignUpDto } from "#modules/auth/infra/signUp.api";
import { useUpdateUser } from "#modules/users/view/useUpdateUser";
import { ROUTES } from "#shared/routes";
import { Center } from "#shared/view/components/Center";
import { Flex } from "#shared/view/components/Flex";
import { Paper } from "#shared/view/components/Paper";
import { Stack } from "#shared/view/components/Stack";
import { ThreeStepsStepper } from "#shared/view/components/Stepper";
import { Button } from "#shared/view/designSystem/Button";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";

export const SetUserPage = () => {
  const navigate = useNavigate();
  const { updateUser } = useUpdateUser({
    onSuccess: () => {
      navigate(ROUTES.partnerSetCompany);
    },
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignUpDto>();

  const { t } = useTranslation();

  const onSubmit = async (data: { firstName: string; lastName: string }) => {
    updateUser(data);
  };

  return (
    <Paper style={styles.paper}>
      <Paper p="lg" shadow="lg">
        <Stack gap={"xs"} align="center">
          <Flex align="center" justify="center">
            <img alt="" src="/logo-fabera-login.png" width="139" height="60" />
          </Flex>
          <Flex align="center" justify="center">
            <ThreeStepsStepper
              active={1}
              firstStep={t("login.step1")}
              firstDescription={t("login.step1Description")}
              secondStep={t("login.step2")}
              secondDescription={t("login.step2Description")}
              finalStep={t("login.step3")}
              finalDescription={t("login.step3Description")}
            />
          </Flex>
          <form onSubmit={handleSubmit(onSubmit)} style={{ minWidth: 400 }}>
            <TextInput
              mt="xs"
              withAsterisk
              label={t("login.firstName")}
              error={errors.firstName ? t("login.firstNameRequired") : null}
              {...register("firstName", {
                required: true,
              })}
            />
            <TextInput
              mt="xs"
              withAsterisk
              label={t("login.lastName")}
              error={errors.lastName ? t("login.lastNameRequired") : null}
              {...register("lastName", {
                required: true,
              })}
            />
            <Center>
              <Button
                rightSection={<IconArrowRight size={14} />}
                mt="xs"
                size="md"
                variant="filled"
                type="submit"
              >
                {t("login.validate")}
              </Button>
            </Center>
          </form>
        </Stack>
      </Paper>
    </Paper>
  );
};

const styles = {
  paper: {
    height: "100vh",
    width: "100wh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--Blue-gradient, linear-gradient(103deg, #2955E2 1.95%, #0B267B 91.53%))",
  },
};
